<template>
  <form @submit.prevent="generateReportDownloads">
    <md-card>
      <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>trending_up</md-icon>
        </div>
        <h4 class="title">
          Descargas
        </h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Fecha Inicio
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-datepicker v-model="download.startDate" :disabled="disabled"/>
              <validation-error :errors="apiValidationErrors.startDate"/>
            </md-field>
          </div>
        </div>

      </md-card-content>

      <md-card-content>
        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Fecha Final
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-datepicker v-model="download.finishDate" :disabled="disabled"/>
              <validation-error :errors="apiValidationErrors.finishDate"/>
            </md-field>
          </div>
        </div>

      </md-card-content>

      <md-card-actions>
        <md-button type="submit" :disabled="disabled">
          Generar Reporte
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>

<script>

import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {get} from "lodash";

export default {
  name: "DownloadsCard",
  components: {ValidationError},
  mixins: [formMixin],
  data: () => ({
    disabled: false,
    download: {
      startDate: null,
      finishDate: null,
      type: 'downloads',
    },
  }),
  methods: {
    async generateReportDownloads() {
      try {

        this.disabled = true;

        if (!this.download.startDate || !this.download.finishDate) {
          this.disabled = false;

          await this.$store.dispatch(
              "alerts/error",
              'Debes de seleccionar fechas válidas'
          );

          return false;
        }

        await this.$store.dispatch("reports/downloads", this.download);

        const response = await this.createReport();
        await this.resetForm();

        await this.$store.dispatch(
            response ? "alerts/success" : "alerts/warning",
            response ? "Se ha Generado Reporte Correctamente." : "No hay datos para generar el reporte"
        );

        this.disabled = false;

      } catch (e) {
        this.disabled = false;
        await this.$store.dispatch(
            "alerts/error",
            `Oops, ${e.message}!`
        );

        this.setApiValidation(e.response.data.error);
      }
    },

    async createReport() {

      try {
        let data = await this.$store.getters["reports/downloads"];

        if (data.length > 0) {
          let csvData = [];

          for (const index in data) {
            csvData.push([
              data[index]?.project !== null ? data[index]?.project?.replace(/(\r\n|\n|\r)/gm, " ") : data[index]?.project,
              data[index]?.typeLine !== null ? data[index]?.typeLine?.replace(/(\r\n|\n|\r)/gm, " ") : data[index]?.typeLine,
              data[index]?.phone !== null ? data[index]?.phone?.replace(/(\r\n|\n|\r)/gm, " ") : data[index]?.phone,
              data[index]?.uuid !== null ? data[index]?.uuid?.replace(/(\r\n|\n|\r)/gm, " ") : data[index]?.uuid,
              data[index]?.date !== null ? data[index]?.date?.replace(/(\r\n|\n|\r)/gm, " ") : data[index]?.date,
            ]);
          }

          let csv = "PROJECTO\tLINEA\tTELEFONO\tUUID\tFECHA\n";

          csvData.forEach((row) => {
            csv += row.join("\t");
            csv += "\n";
          });

          let anchor = document.createElement('a');
          anchor.href = 'data:text/csv;charset=ANSI,' + encodeURIComponent(csv);
          anchor.target = '_blank';
          anchor.download = 'ReporteDescargas.xls';
          anchor.click();

          return true;
        }

        return false;

      } catch (e) {
        this.disabled = false;
        await this.$store.dispatch(
            "alerts/error",
            `Oops, ${e.message}!`
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
    async resetForm() {
      this.download = {...this.download, startDate: null, finishDate: null};
    }
  },
}
</script>
